import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { ProtectedRoute } from './components/ProtectedRoute'
import { SiteHeader } from './components/layout/SiteHeader'
import { LoginPage } from './pages/LoginPage'
import { AssessmentPage } from './pages/AssessmentPage'
import { DashboardPage } from './pages/DashboardPage'
import { AnalyticsPage } from './pages/AnalyticsPage'
import { RunDetailPage } from './pages/RunDetailPage'
import { AdminPage } from './pages/AdminPage'
import { SetupPage } from './pages/SetupPage'
import DiagnosticPage from './pages/DiagnosticPage'
import PractitionerDiagnosticPage from './pages/PractitionerDiagnosticPage'
import { useIdleTimeout } from './hooks/useIdleTimeout'

// Inner component so useIdleTimeout can access AuthProvider context
function AppContent() {
  useIdleTimeout() // Sign out after 30 min of inactivity
  return (
    <>
      <SiteHeader />
      <Routes>
          {/* ---- Public: login ---- */}
          <Route path="/login" element={<LoginPage />} />

          {/* ---- Public: respondent-facing assessment ---- */}
          {/* /r/:token supports UUID (pre-registered) and integer (legacy shared-URL) */}
          <Route path="/r/:token" element={<AssessmentPage />} />

          {/* ---- Public: OCM Complexity Diagnostic ---- */}
          <Route path="/diagnostic"                element={<DiagnosticPage />} />
          <Route path="/diagnostic/:engagementId"  element={<PractitionerDiagnosticPage />} />

          {/* ---- Protected: consultant + client admin facing ---- */}
          <Route
            path="/dashboard"
            element={<ProtectedRoute><DashboardPage /></ProtectedRoute>}
          />
          <Route
            path="/analytics"
            element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>}
          />
          <Route
            path="/runs/:runId"
            element={<ProtectedRoute><RunDetailPage /></ProtectedRoute>}
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute requireRole={['clutch_admin', 'clutch_consultant']}>
                <AdminPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/setup"
            element={
              <ProtectedRoute requireRole="clutch_admin">
                <SetupPage />
              </ProtectedRoute>
            }
          />

          {/* ---- Redirects ---- */}
          <Route path="/"       element={<Navigate to="/dashboard" replace />} />
          <Route path="/assess" element={<Navigate to="/dashboard" replace />} />
          <Route path="*"       element={<Navigate to="/dashboard" replace />} />
        </Routes>
    </>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  )
}
